/* ── ── SPCore · Media flip — front/back (multi-side) slide carousel + shared zoom modal ── */
(function () {
  if (window.__spFlip) return;
  window.__spFlip = 1;

  function imgs(flip) { return Array.prototype.slice.call(flip.querySelectorAll('.sp-flip__img')); }
  function urls(flip) { return imgs(flip).map(function (im) { return im.getAttribute('data-zoom-src') || im.src; }); }
  function indexOf(flip) { return parseInt(flip.getAttribute('data-flip-index'), 10) || 0; }

  /* ── inline carousel ── */
  function show(flip, i) {
    var n = imgs(flip).length;
    if (n < 2) return;
    i = (i % n + n) % n;
    flip.setAttribute('data-flip-index', i);
    var track = flip.querySelector('.sp-flip__track');
    if (track) track.style.transform = 'translateX(-' + (i * 100) + '%)';
    flip.querySelectorAll('.sp-flip__dot').forEach(function (d, di) {
      d.classList.toggle('is-active', di === i);
    });
  }

  var modal, mTrack, mDots, mUrls = [], mIdx = 0, mInterval = 0, mElapsed = 0;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'sp-flip-zoom';
    modal.innerHTML =
      '<div class="sp-flip-zoom__backdrop" data-zoom-close></div>' +
      '<div class="sp-flip-zoom__dialog" role="dialog" aria-modal="true" aria-label="Image preview">' +
        '<button type="button" class="sp-flip-zoom__close sp-icon-btn sp-icon-btn--shadow" data-zoom-close aria-label="Close">' +
          '<svg class="sp-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>' +
        '</button>' +
        '<div class="sp-flip-zoom__stage"><div class="sp-flip-zoom__track"></div></div>' +
        '<div class="sp-flip-zoom__bar">' +
          '<div class="sp-flip__nav sp-flip__nav--lg">' +
            '<button type="button" class="sp-flip__arrow sp-flip__arrow--prev" data-zoom-step="-1" aria-label="Previous">&#8249;</button>' +
            '<div class="sp-flip__dots" data-zoom-dots></div>' +
            '<button type="button" class="sp-flip__arrow sp-flip__arrow--next" data-zoom-step="1" aria-label="Next">&#8250;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    mTrack = modal.querySelector('.sp-flip-zoom__track');
    mDots = modal.querySelector('[data-zoom-dots]');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoom-close]')) { closeModal(); return; }
      var to = e.target.closest('[data-zoom-to]');
      if (to) { mIdx = parseInt(to.getAttribute('data-zoom-to'), 10) || 0; mElapsed = 0; renderModal(); return; }
      var step = e.target.closest('[data-zoom-step]');
      if (step) { mElapsed = 0; stepModal(parseInt(step.getAttribute('data-zoom-step'), 10) || 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowLeft') { mElapsed = 0; stepModal(-1); }
      else if (e.key === 'ArrowRight') { mElapsed = 0; stepModal(1); }
    });
  }

  function renderModal() {
    mTrack.style.transform = 'translateX(-' + (mIdx * 100) + '%)';
    var dots = mDots.children;
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === mIdx);
  }

  function stepModal(d) {
    if (mUrls.length < 2) return;
    mIdx = (mIdx + d + mUrls.length) % mUrls.length;
    renderModal();
  }

  function openModal(flip) {
    if (!modal) { buildModal(); void modal.offsetWidth; }
    mUrls = urls(flip);
    if (!mUrls.length) return;
    var alt = flip.getAttribute('data-flip-alt') || '';
    mIdx = Math.min(indexOf(flip), mUrls.length - 1);
    mTrack.textContent = '';
    mDots.textContent = '';
    mUrls.forEach(function (u, i) {
      var im = document.createElement('img');
      im.className = 'sp-flip-zoom__img';
      im.src = u;
      im.alt = alt;
      mTrack.appendChild(im);
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sp-flip__dot';
      dot.setAttribute('data-zoom-to', i);
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      mDots.appendChild(dot);
    });
    modal.classList.toggle('sp-flip-zoom--multi', mUrls.length > 1);
    renderModal();

    var ap = parseInt(flip.getAttribute('data-flip-autoplay'), 10);
    mInterval = (!reduced() && mUrls.length > 1 && ap) ? ap : 0;
    mElapsed = 0;
    modal.classList.toggle('is-playing', !!mInterval);
    modal.style.setProperty('--sp-flip-progress', '0%');

    modal.classList.add('is-open');
    document.documentElement.classList.add('sp-modal-open');
    if (mInterval) ensureLoop();
    if (window.SPCore && SPCore.a11y) SPCore.a11y.trapFocus(modal.querySelector('.sp-flip-zoom__dialog'));
  }

  function closeModal() {
    if (!modal) return;
    mInterval = 0;
    modal.classList.remove('is-open', 'is-playing');
    document.documentElement.classList.remove('sp-modal-open');
    if (window.SPCore && SPCore.a11y) SPCore.a11y.removeTrapFocus();
  }

  var state = new WeakMap();
  var running = false, lastNow = 0;

  function reduced() {
    return window.SPCore && SPCore.config
      ? SPCore.config.motionReduced
      : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resetTimer(flip) { var st = state.get(flip); if (st) st.elapsed = 0; }

  function scan() {
    if (reduced()) return;
    document.querySelectorAll('.sp-flip[data-flip-autoplay]').forEach(function (flip) {
      if (state.has(flip)) return;
      var interval = parseInt(flip.getAttribute('data-flip-autoplay'), 10);
      if (!interval || imgs(flip).length < 2) return;
      state.set(flip, { interval: interval, elapsed: 0 });
      flip.classList.add('is-playing');
    });
    ensureLoop();
  }

  function ensureLoop() {
    if (running) return;
    running = true; lastNow = 0;
    requestAnimationFrame(tick);
  }

  function tick(now) {
    var dt = lastNow ? Math.min(now - lastNow, 100) : 0;
    lastNow = now;
    var list = document.querySelectorAll('.sp-flip.is-playing');
    var modalPlaying = modal && mInterval && modal.classList.contains('is-open');
    if (!list.length && !modalPlaying) { running = false; return; }

    var inlineFrozen = document.documentElement.classList.contains('sp-modal-open') || document.hidden;
    list.forEach(function (flip) {
      var st = state.get(flip);
      if (!st) return;
      if (!inlineFrozen) {
        st.elapsed += dt;
        if (st.elapsed >= st.interval) { st.elapsed = 0; show(flip, indexOf(flip) + 1); }
      }
      flip.style.setProperty('--sp-flip-progress', Math.min(st.elapsed / st.interval, 1) * 100 + '%');
    });

    if (modalPlaying) {
      if (!document.hidden) {
        mElapsed += dt;
        if (mElapsed >= mInterval) { mElapsed = 0; stepModal(1); }
      }
      modal.style.setProperty('--sp-flip-progress', Math.min(mElapsed / mInterval, 1) * 100 + '%');
    }
    requestAnimationFrame(tick);
  }

  function observe() {
    if (!window.MutationObserver) return;
    var deb = window.SPCore && SPCore.utils ? SPCore.utils.debounce(scan, 150) : scan;
    new MutationObserver(deb).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ── delegated inline controls ── */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.sp-flip__dot');
    if (dot) { var f1 = dot.closest('.sp-flip'); if (f1) { show(f1, parseInt(dot.getAttribute('data-flip-to'), 10) || 0); resetTimer(f1); } return; }

    var arrow = e.target.closest('.sp-flip__arrow');
    if (arrow) { var f2 = arrow.closest('.sp-flip'); if (f2) { show(f2, indexOf(f2) + (parseInt(arrow.getAttribute('data-flip-step'), 10) || 1)); resetTimer(f2); } return; }

    var frame = e.target.closest('.sp-flip__frame--zoom');
    if (frame) { e.preventDefault(); var f3 = frame.closest('.sp-flip'); if (f3) openModal(f3); }
  });

  /* ── boot ── */
  function boot() { scan(); observe(); }
  if (window.SPCore && SPCore.DOMready) SPCore.DOMready(boot);
  else if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot, { once: true });
})();
